import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { getStatusDisplayName } from "@/utils/statusMappings";

interface ActiveFiltersDisplayProps {
  selectedStatuses: string[];
  onRemoveStatus: (status: string) => void;
  onClearAll: () => void;
}

const ActiveFiltersDisplay = ({
  selectedStatuses,
  onRemoveStatus,
  onClearAll
}: ActiveFiltersDisplayProps) => {
  if (selectedStatuses.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2 py-2">
      <span className="text-sm text-muted-foreground">Actieve filters:</span>
      {selectedStatuses.map((status) => (
        <Badge
          key={status}
          variant="secondary"
          className="gap-1 pr-1 cursor-pointer hover:bg-secondary/80"
        >
          {getStatusDisplayName(status)}
          <button
            onClick={() => onRemoveStatus(status)}
            className="ml-1 rounded-full hover:bg-background/50 p-0.5"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      {selectedStatuses.length > 1 && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearAll}
          className="h-6 text-xs"
        >
          Alle filters wissen
        </Button>
      )}
    </div>
  );
};

export default ActiveFiltersDisplay;
